<scw-mat-button
  type="standard"
  [block]="block"
  [disabled]="disabled"
  [className]="className"
  (onClick)="onClickEmitter()"
>
  <ng-content></ng-content>
</scw-mat-button>
